import { takeLeading } from 'redux-saga/effects';
import { get, isNull } from 'lodash';
import { callApi } from 'helpers/saga-helpers';
import userToken from 'containers/services/security/access-token-storage';
import { setPendingTreatementClaims } from 'containers/ManagerPendingTreatementClaims/actions';
import {
  REQUEST_PENDING_TREATEMENT_CLAIMS,
  REQUEST_SEARCH_PENDING_TREATEMENT_CLAIMS,
} from 'containers/ManagerPendingTreatementClaims/constants';

export function* getPendingTreatementManager(action: any): Generator<unknown> {
  const token = get(userToken.get(), 'token');
  if (isNull(token)) return;
  const { payload } = action;
  const path = get(payload, 'isTransactionManager', false)
    ? `/corporeal/notification-manager-transaction/get-pending-notification?page=${payload.page}&pageSize=${payload.pageSize}`
    : `/corporeal/notification-manager/get-pending-notification?page=${payload.page}&pageSize=${payload.pageSize}`;

  const options = {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], setPendingTreatementClaims);
}

export function* requestGetPendingTreatementManager() {
  yield takeLeading(
    REQUEST_PENDING_TREATEMENT_CLAIMS,
    getPendingTreatementManager,
  );
}

export function* requestSearchPendingTreatementClaims(
  action: any,
): Generator<unknown> {
  const token = get(userToken.get(), 'token');
  if (isNull(token)) return;
  const { payload } = action;
  const path = get(payload, 'isTransactionManager', false)
    ? `/corporeal/notification-manager-transaction/search-pending-treatement-claims`
    : `/corporeal/notification-manager/search-pending-treatement-claims`;

  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      claimNumber: payload.claimNumber,
    }),
  };
  yield callApi(path, {}, options, [], setPendingTreatementClaims);
}
export function* requestSearchPendingTreatementManagerSaga() {
  yield takeLeading(
    REQUEST_SEARCH_PENDING_TREATEMENT_CLAIMS,
    requestSearchPendingTreatementClaims,
  );
}
export default [
  requestGetPendingTreatementManager,
  requestSearchPendingTreatementManagerSaga,
];
